module.exports = __webpack_public_path__ + "static/media/promo.62118aab.jpg";